import { render } from "./LuxuryTravel01.vue?vue&type=template&id=37f9e05c&scoped=true"
import script from "./LuxuryTravel01.vue?vue&type=script&lang=js"
export * from "./LuxuryTravel01.vue?vue&type=script&lang=js"

import "./LuxuryTravel01.scss?vue&type=style&index=0&id=37f9e05c&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f9e05c"]])

export default __exports__